import { Injectable } from "@angular/core";
import { HttpService } from "app/js/src/infrastructure/http/http";
import { IClippingStudioGfxRepository } from "app/js/src/domain/clipping-studio/i-clipping-studio-gfx-repository";
import { GfxCacheResult } from "app/js/src/domain/clipping-studio/clipping-studio-gfx-models";
import { environment } from "app/environments/environment";

@Injectable()
export class ClippingStudioGfxHttpRepositoryService extends IClippingStudioGfxRepository {
  private readonly baseUrl = "clipping-studio/gfx";

  constructor(private readonly httpService: HttpService) {
    super();
  }

  async materializeGfx(instanceId: number): Promise<GfxCacheResult> {
    const res = await this.httpService.post(`${this.baseUrl}/materialize`, {
      instance_id: instanceId,
    });
    const data = res?.Data ?? res?.data ?? res;
    // Support both IChannelResponse-style and validation_error payloads
    if (data?.success === false) {
      return {
        isSuccess: false,
        status: "error",
        error: data?.error ?? "materialize_failed",
        message: data?.message ?? "materialize_failed",
      };
    }
    return {
      isSuccess: data.IsSuccess ?? data.isSuccess ?? false,
      status: ((data.Status ?? data.status ?? "pending") as string).toLowerCase() as GfxCacheResult["status"],
      error: data.Error ?? data.error ?? null,
      message: data.Message ?? data.message ?? data.ErrorMessage ?? data.errorMessage ?? null,
    };
  }

  async getGfxUrl(instanceId: number): Promise<string> {
    const res = await this.httpService.get(
      `${this.baseUrl}/url/${encodeURIComponent(instanceId)}`,
    );
    const data = res?.Data ?? res?.data ?? res;
    const raw =
      typeof data === "string"
        ? data
        : (data?.ServeUrl ?? data?.serveUrl ?? data?.url ?? "");

    if (!raw) return "";
    if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;

    return environment.ENDPOINT.replace(/\/$/, "") + raw;
  }
}
